import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExcelExporterFunctionInput  {
    _originalTypeClassName = "zERP.BO.ExcelExporterFunctionInput";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExcelExporterFunctionInput.translate = translateService;
}
this.Name = null;
this.Datatype = null;
this.Description = null;
this.ExcelExporterFunctionInputKey = null;
this._key = this.ExcelExporterFunctionInputKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Datatype:any;
Description:any;
private _ExcelExporterFunctionInputKey:any;
get ExcelExporterFunctionInputKey(): any {
    return this._ExcelExporterFunctionInputKey;
  }
set ExcelExporterFunctionInputKey(value: any) {
    this._ExcelExporterFunctionInputKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ExcelExporterFunctionInputKey == null || $this.ExcelExporterFunctionInputKey == 0;
            }


}